import PublicPageTemplate from '../../components/PublicPageTemplate/PublicPageTemplate';
import { useFormConfig } from '../../hooks/useFormConfig';

function CookiesScreen() {
  const { formConfig } = useFormConfig();
  const serviceName = (formConfig as any)?.serviceName || 'GRID GovReturns';

  return (
    <PublicPageTemplate title={`Cookies on ${serviceName}`} fullWidth>
      <p className="govuk-body">Last updated: 11 February 2026</p>
      <p className="govuk-body">
        Cookies are small files saved on your phone, tablet or computer when you visit a website.
      </p>
      <p className="govuk-body">
        This service currently does not set first-party cookies on forms.grid.civilservice.gov.uk.
      </p>
      <p className="govuk-body">
        This service is run by Cabinet Office Digital, GRID GovReturns Team.
      </p>

      <h2 className="govuk-heading-m">Cookies used by this service</h2>
      <p className="govuk-body">
        We have checked this application and API responses and there are currently no cookies set by
        this service.
      </p>
      <table className="govuk-table">
        <thead className="govuk-table__head">
          <tr className="govuk-table__row">
            <th scope="col" className="govuk-table__header">
              Name
            </th>
            <th scope="col" className="govuk-table__header">
              Purpose
            </th>
            <th scope="col" className="govuk-table__header">
              Expires
            </th>
          </tr>
        </thead>
        <tbody className="govuk-table__body">
          <tr className="govuk-table__row">
            <td className="govuk-table__cell">None</td>
            <td className="govuk-table__cell">No first-party cookies are currently set</td>
            <td className="govuk-table__cell">N/A</td>
          </tr>
        </tbody>
      </table>

      <h2 className="govuk-heading-m">Browser storage used by this service</h2>
      <p className="govuk-body">
        Instead of cookies, this service stores sign-in and navigation state in your browser&apos;s
        local and session storage to keep you signed in and route you to the correct form.
      </p>
      <h3 className="govuk-heading-s">Local storage keys</h3>
      <table className="govuk-table">
        <thead className="govuk-table__head">
          <tr className="govuk-table__row">
            <th scope="col" className="govuk-table__header">
              Key
            </th>
            <th scope="col" className="govuk-table__header">
              Purpose
            </th>
          </tr>
        </thead>
        <tbody className="govuk-table__body">
          <tr className="govuk-table__row">
            <td className="govuk-table__cell">oidc.user:*</td>
            <td className="govuk-table__cell">Stores your GRID sign-in tokens after you sign in through COLA</td>
          </tr>
        </tbody>
      </table>
      <h3 className="govuk-heading-s">Session storage keys</h3>
      <table className="govuk-table">
        <thead className="govuk-table__head">
          <tr className="govuk-table__row">
            <th scope="col" className="govuk-table__header">
              Key
            </th>
            <th scope="col" className="govuk-table__header">
              Purpose
            </th>
          </tr>
        </thead>
        <tbody className="govuk-table__body">
          <tr className="govuk-table__row">
            <td className="govuk-table__cell">authTabSessionId</td>
            <td className="govuk-table__cell">Identifies the current browser tab session</td>
          </tr>
          <tr className="govuk-table__row">
            <td className="govuk-table__cell">selectedFormId-{`{tenant}`}</td>
            <td className="govuk-table__cell">Stores the active form ID for navigation</td>
          </tr>
          <tr className="govuk-table__row">
            <td className="govuk-table__cell">LastLocation</td>
            <td className="govuk-table__cell">Stores last route for redirect after sign in</td>
          </tr>
        </tbody>
      </table>

      <h2 className="govuk-heading-m">Analytics cookies</h2>
      <p className="govuk-body">This service does not currently use analytics cookies.</p>

      <h2 className="govuk-heading-m">Managing cookies</h2>
      <p className="govuk-body">
        Find out{' '}
        <a
          className="govuk-link"
          href="https://ico.org.uk/for-the-public/online/cookies/"
          target="_blank"
          rel="noreferrer"
        >
          how to manage cookies
        </a>
        .
      </p>
      <h2 className="govuk-heading-m">Contact</h2>
      <p className="govuk-body">
        For questions about cookies in GRID GovReturns, contact Cabinet Office Digital, GRID
        GovReturns Team at{' '}
        <a className="govuk-link" href="mailto:grid-platform@cabinetoffice.gov.uk">
          grid-platform@cabinetoffice.gov.uk
        </a>
        .
      </p>

    </PublicPageTemplate>
  );
}

export default CookiesScreen;
